import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accountModal: false,
    savedModal: false,
    // Rent page search params
    rent: {
      distance: null,
      category_id: [],
      amenity_id: [],
      feature_id: [],
      from_date: null,
      to_date: null,
      from_price: null,
      to_price: null,
      from_footfall: null,
      to_footfall: null,
      location_type: null,
      query: null,
      lat: null,
      lng: null,
      bounds: {
        latitude: null,
        longitude: null,
        latitude2: null,
        longitude2: null
      },
    },
    translations: {}
  },
  getters: {
      language: state => {
          return state.translations
      }
  },
  mutations: {
    accountModal (state, data) {
      state.accountModal = data
    },
    savedModal (state, data) {
      state.savedModal = data
    },
    distance (state, data) {
      state.rent.distance = data
    },
    category_id (state, data) {
      state.rent.category_id = data
    },
    amenity_id (state, data) {
      state.rent.amenity_id = data
    },
    feature_id (state, data) {
      state.rent.feature_id = data
    },
    from_footfall (state, data) {
      state.rent.from_footfall = data
    },
    to_footfall (state, data) {
      state.rent.to_footfall = data
    },
    from_date (state, data) {
      state.rent.from_date = data
    },
    to_date (state, data) {
      state.rent.to_date = data
    },
    from_price (state, data) {
      state.rent.from_price = data
    },
    to_price (state, data) {
      state.rent.to_price = data
    },
    location_type (state, data) {
      state.rent.location_type = data
    },
    bounds (state, data) {
      state.rent.bounds = data
    },
    lat (state, data) {
      state.rent.lat = data
    },
    lng (state, data) {
      state.rent.lng = data
    },
    query (state, data) {
      state.rent.query = data
    },
    setTranslations (state, data) {
      state.translations = data
    },
    replace (state, data) {
      state.rent.category_id = data.category_id
      state.rent.feature_id = data.feature_id
      state.rent.type_id = data.type_id
      state.rent.from_date = data.from_date
      state.rent.to_date = data.to_date
      state.rent.from_price = data.from_price
      state.rent.to_price = data.to_price
      state.rent.location_type = data.location_type
      state.rent.from_footfall = data.from_footfall
      state.rent.to_footfall = data.to_footfall
    },
    reset (state, data) {
      state.rent = data
    }
  },
  actions: {
  },
  modules: {
  }
})
